import menus from "../menus/index.js";
import mutations from "./mutations";

const header = {
  namespaced: true,
  state: {
    serviceName: "XBase Service",
    userName: null,
    userEmail: "",
    serviceMenu: menus,
    permission: {},
    userProfile: {
      userId: "",
      userName: "",
      roles: [""],
      sgID: "201800001A",
      sgIDType: 1,
      profileType: 1,
      nric: "",
      additionalProfileInfo: {},
      isValidated: true,
      canImpersonate: false
    },
    isImpersonating: false,
    hasProfile: false
  },
  mutations
};

export default header;
